/** Compact touch navigation. Uses the same cursor and callbacks as the vertical replay slider. */
export function BoardMoveProgress({
  value,
  max,
  disabled,
  busy = false,
  onChange,
}: {
  readonly value: number;
  readonly max: number;
  readonly disabled: boolean;
  readonly busy?: boolean;
  readonly onChange: (value: number) => void;
}) {
  return (
    <label className="workspace-mobile-progress">
      <input
        type="range"
        min={0}
        max={max}
        value={value}
        disabled={disabled}
        className={busy ? 'is-busy' : undefined}
        aria-busy={busy}
        aria-label="棋谱进度"
        aria-valuetext={`第 ${value} 手，共 ${max} 手`}
        onChange={(event) => onChange(Number(event.currentTarget.value))}
      />
      <span>
        {value} / {max} 手
      </span>
    </label>
  );
}
